import axios from 'axios';
import { enforceAdminSessionTimeout, getCurrentAppPath, redirectToAppPath } from './adminSession';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || '/',
});

api.interceptors.request.use(config => {
  if (enforceAdminSessionTimeout()) {
    if (typeof window !== 'undefined' && getCurrentAppPath() !== '/login') {
      redirectToAppPath('/login');
    }
    return Promise.reject(new Error('Admin session expired due to inactivity'));
  }

  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
